import React, { useCallback } from 'react';
import { appSettings } from 'AppSettings';
import useAuth from 'auth/UseAuth';
import { BaseDownloadFile } from '../../data/BaseData';
import { DownloadButton } from '../../components/DownloadButton';

export interface InventoryCheckRequestSamplesExportButtonProps {
  inventoryCheckRequestId: string;
}

export const InventoryCheckRequestSamplesExportButton = ({
  inventoryCheckRequestId,
}: InventoryCheckRequestSamplesExportButtonProps) => {
  const { accessToken } = useAuth();

  const downloadData = useCallback(async () => {
    let url = `${appSettings.api.endpoint}/api/v2/InventoryCheckRequests/${inventoryCheckRequestId}/Samples?exportType=xlsx`;
    await BaseDownloadFile(url, accessToken);
  }, [accessToken, inventoryCheckRequestId]);

  return (
    <DownloadButton
      id='disease-count-export-button'
      downloadData={downloadData}
      sx={[
        {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      ]}
    />
  );
};
